/* eslint-disable no-control-regex */

export const regex = {
	telephone: /^0\d{10}$/,
	phone: /^09\d{9}$/,
	fullname: /^(?=.*[آ-ی]+.*[\s]+.*[آ-ی]+).{3,}$/,
	faName: /^[آ-ی\s]{2,50}$/,
	otp: /^\d{6}$/,
	postalCode: /^\d{10}$/,
	address: /^.{5,}$/,
};
